/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../$$_gendir/node_modules/ng2-bootstrap/alert/alert.component.ngfactory';
import * as i2 from 'ng2-bootstrap/alert/alert.component';
import * as i3 from 'ng2-bootstrap/alert/alert.config';
import * as i4 from 'ng2-translate/src/translate.pipe';
import * as i5 from 'ng2-translate/src/translate.service';
import * as i6 from '@angular/common';
import * as i7 from '../../../../../app/components/widgets/alert-box/alert-box.component';
const styles_AlertBoxWidget:any[] = ([] as any[]);
export const RenderType_AlertBoxWidget:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AlertBoxWidget,data:{}});
function View_AlertBoxWidget_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'alert',[['type',
      'success']],(null as any),(null as any),(null as any),i1.View_AlertComponent_0,
      i1.RenderType_AlertComponent)),i0.ɵdid(1,114688,(null as any),0,i2.AlertComponent,
      [i3.AlertConfig],{type:[0,'type']},(null as any)),(_l()(),i0.ɵted(2,0,['\n  ',
      '\n'])),i0.ɵpid(131072,i4.TranslatePipe,[i5.TranslateService,i0.ChangeDetectorRef])],
      (_ck,_v) => {
        const currVal_0:any = 'success';
        _ck(_v,1,0,currVal_0);
      },(_ck,_v) => {
        const currVal_1:any = i0.ɵunv(_v,2,0,i0.ɵnov(_v,3).transform(_v.context.$implicit));
        _ck(_v,2,0,currVal_1);
      });
}
function View_AlertBoxWidget_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'alert',[['type',
      'danger']],(null as any),(null as any),(null as any),i1.View_AlertComponent_0,
      i1.RenderType_AlertComponent)),i0.ɵdid(1,114688,(null as any),0,i2.AlertComponent,
      [i3.AlertConfig],{type:[0,'type']},(null as any)),(_l()(),i0.ɵted(2,0,['\n  ',
      '\n'])),i0.ɵpid(131072,i4.TranslatePipe,[i5.TranslateService,i0.ChangeDetectorRef])],
      (_ck,_v) => {
        const currVal_0:any = 'danger';
        _ck(_v,1,0,currVal_0);
      },(_ck,_v) => {
        const currVal_1:any = i0.ɵunv(_v,2,0,i0.ɵnov(_v,3).transform(_v.context.$implicit));
        _ck(_v,2,0,currVal_1);
      });
}
export function View_AlertBoxWidget_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AlertBoxWidget_1)),i0.ɵdid(1,802816,(null as any),0,i6.NgForOf,[i0.ViewContainerRef,
      i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_AlertBoxWidget_2)),i0.ɵdid(4,802816,(null as any),0,i6.NgForOf,
      [i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},
      (null as any))],(_ck,_v) => {
    var _co:i7.AlertBoxWidget = _v.component;
    const currVal_0:any = _co.successes;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.errors;
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_AlertBoxWidget_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'alert-box',
      ([] as any[]),(null as any),(null as any),(null as any),View_AlertBoxWidget_0,
      RenderType_AlertBoxWidget)),i0.ɵdid(1,49152,(null as any),0,i7.AlertBoxWidget,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const AlertBoxWidgetNgFactory:i0.ComponentFactory<i7.AlertBoxWidget> = i0.ɵccf('alert-box',
    i7.AlertBoxWidget,View_AlertBoxWidget_Host_0,{errors:'errors',successes:'successes'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2FsZXJ0LWJveC9hbGVydC1ib3guY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2FsZXJ0LWJveC9hbGVydC1ib3guY29tcG9uZW50LnRzIiwibmc6Ly8vdXNyL3NyYy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3dpZGdldHMvYWxlcnQtYm94L2FsZXJ0LWJveC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2FsZXJ0LWJveC9hbGVydC1ib3guY29tcG9uZW50LnRzLkFsZXJ0Qm94V2lkZ2V0X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFsZXJ0IHR5cGU9XCJzdWNjZXNzXCIgKm5nRm9yPVwibGV0IHN1Y2Nlc3Mgb2Ygc3VjY2Vzc2VzXCI+XG4gIHt7c3VjY2VzcyB8IHRyYW5zbGF0ZX19XG48L2FsZXJ0PlxuPGFsZXJ0IHR5cGU9XCJkYW5nZXJcIiAqbmdGb3I9XCJsZXQgZXJyb3Igb2YgZXJyb3JzXCI+XG4gIHt7ZXJyb3IgfCB0cmFuc2xhdGV9fVxuPC9hbGVydD4iLCI8YWxlcnQtYm94PjwvYWxlcnQtYm94PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBLGtEQUF3RDtNQUFBOztRQUFqRDtRQUFQLFdBQU8sU0FBUDs7UUFBd0Q7UUFBQTs7OztvQkFHeEQ7TUFBQTtrQ0FBQSxVQUFBO01BQUEsa0RBQWtEO01BQUE7O1FBQTNDO1FBQVAsV0FBTyxTQUFQOztRQUFrRDtRQUFBOzs7O29CQUhsRDtNQUFBLCtCQUFBO3VDQUFBLHlDQUVRO2FBQUEsMkJBQ1I7TUFBQSwrQ0FBQTtNQUFBO01BQUE7O0lBSHNCO0lBQXRCLFdBQXNCLFNBQXRCO0lBR3FCO0lBQXJCLFdBQXFCLFNBQXJCOzs7O29CQ0hBO01BQUE7K0JBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/alert-box/alert-box.component.ngfactory.ts